module.exports = __webpack_public_path__ + "img/shake.61e512ec.jpg";